
































const namespace = 'calendar';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import CalendarTimeline from '@/modules/calendar/components/CalendarTimeline.vue';
import DropdownFilter from '@/modules/calendar/components/DropdownFilter.vue';
import CalendarHeaders from '@/modules/calendar/components/CalendarHeaders.vue';
import CalendarDays from '@/modules/calendar/components/CalendarDays.vue';
import ICalendarData from '@/modules/calendar/interfaces/ICalendarData';
import { WeekDaysEvents } from '@/modules/calendar/store/types';

@Component({
    name: 'CalendarContent',
    components: {
        CalendarHeaders,
        CalendarDays,
        CalendarTimeline,
        DropdownFilter,
    },
})
export default class CalendarContent extends Vue {
    @Prop() public events!: ICalendarData[];
    @Prop() private boxType!: string;
    @Getter('hoursWithEvents', { namespace }) private hoursWithEvents!: number;
    @Getter('isMobile', { namespace }) private isMobile!: number;
    @Getter('eventsByWeekDays', { namespace }) private eventsByWeekDays!: WeekDaysEvents[];

    private get mobileView() {
        return this.isMobile;
    }

    private get getEventsByweekDays() {
        return this.eventsByWeekDays;
    }

    private get getHoursRange() {
        return this.hoursWithEvents;
    }

    private get getCountLocationsAndEvents() {
        // eslint-disable-next-line prefer-const
        let countLocations = 0;
        const eventsInHour: { [key: string]: number } = {};
        const arr: number[] = Object.values(eventsInHour).length ? Object.values(eventsInHour) : [0];
        const countEvents = Math.max(...arr);
        return { countLocations, countEvents };
    }

    private get getBoxType(): string {
        return this.boxType;
    }
}
